import { Grid, Typography } from '@material-ui/core'
import * as React from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'

import { ContinueButton } from '../../components/atoms/ContinueButton'
import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionSubTitle, SectionTitle } from '../../components/atoms/SectionTittle'
import { startGame } from '../../services/game-services'
import { textStyles } from '../../styles/TextStyles'
import { invoke } from '../../utils/helper'
import { EscapeRoomDto } from '../../utils/types'

export const GameStarter: React.FC = () => {
    const { state }: { state: { escapeRoom: EscapeRoomDto }} = useLocation()

    const escapeRoom = state?.escapeRoom
    const history = useHistory()

    if (!escapeRoom) {
        return <Redirect to="/"/>
    }
    const classes = textStyles()

    const start = async () => {
        const game = await invoke(async () => {
            return startGame({
                escapeRoomId: escapeRoom.escapeRoomId
            })
        }, {
            operation: 'Start spil'
        })

        window.open(`/spil/${game.gameId}`, '_blank')
        history.push({ pathname: '/spilovervagning' })
    }

    const replace = escapeRoom?.puzzles.map((pz) => {
        return (
            <div key={pz.puzzleId}>
                {pz?.materials?.map((m) => {
                    return (
                        <a
                            key={pz.puzzleId}
                            style={{ color: 'white', textDecoration: 'none' }}
                            target="_blank"
                            href={m.uri}
                            rel="noreferrer">
                            {m.key.replace('puzzles/', '')}
                        </a>
                    )
                })}
            </div>
        )
    })

    return (
        <PageWrapper>
            <SectionTitle text="Start Spil"/>
            <Typography
                className={classes.subTitle}
                variant="h5">
                {escapeRoom.title} Escape Room
            </Typography>

            <Grid
                lg={12}
                spacing={1}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: 50
                }}>
                <Grid
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start'
                    }}
                    item
                    xs={12}>
                    <SectionSubTitle text="Dine escape room opgaver" />
                    <div>{replace}</div>
                </Grid>

                <Grid
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center'
                    }}
                    item
                    spacing={1}
                    xs={12}>
                    <SectionSubTitle text="Begynd tidsrejse " />
                    <ContinueButton
                        title="Start Tidsrejsen!"
                        onClick={start}/>
                </Grid>
            </Grid>

        </PageWrapper>
    )
}
